import { supabase } from '../lib/supabase';
import { Business, CreateBusinessInput } from '../types/business';

export const businessService = {
  async list(): Promise<Business[]> {
    const { data, error } = await supabase
      .from('businesses')
      .select('*')
      .order('is_default', { ascending: false })
      .order('updated_at', { ascending: false });

    if (error) throw new Error(`Failed to load businesses: ${error.message}`);
    return (data || []) as Business[];
  },

  async create(input: CreateBusinessInput): Promise<Business> {
    // owner_id is set by RLS; only allowed if auth.uid() present
    const payload = {
      name: input.name.trim(),
      industry: input.industry || null,
      website: input.website || null,
      stage: input.stage || null,
      target_customer: input.target_customer || null,
      geography: input.geography || null,
      channels: input.channels || null,
      goals: input.goals || null,
      is_default: !!input.is_default,
      // New Phase 1 fields
      revenue_model: (input as any).revenue_model || null,
      team_size: (input as any).team_size || null,
      monthly_revenue: (input as any).monthly_revenue || null,
      unique_value_prop: (input as any).unique_value_prop || null,
      pain_points: (input as any).pain_points || null,
      completed_onboarding: (input as any).completed_onboarding || false,
    };

    const { data, error } = await supabase
      .from('businesses')
      .insert(payload)
      .select('*')
      .single();

    if (error) throw new Error(`Failed to create business: ${error.message}`);
    return data as Business;
  },

  async setDefault(businessId: string): Promise<void> {
    // Unset other defaults, then set one default atomically is tricky client-side.
    // Keep it simple: set this one default; a trigger could enforce single default per owner later.
    const { error } = await supabase
      .from('businesses')
      .update({ is_default: true })
      .eq('id', businessId);

    if (error) throw new Error(`Failed to set default business: ${error.message}`);
  }
};
